import {
    FETCH_USER_DATA_BEGIN,
    FETCH_USER_DATA_SUCCESS,
    FETCH_USER_DATA_ERROR
  } from './fetchUserData';

import {
    UPDATE_ROOM_SUCCESS
} from './updateRoom';

import {
    LEAVE_ROOM_BEGIN,
    LEAVE_ROOM_SUCCESS,
    LEAVE_ROOM_ERROR
} from './leaveRoom';

import auth from 'base/auth';

const initialState = {
    data: null,
    isLoading: false,
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER_DATA_BEGIN:
        case LEAVE_ROOM_BEGIN:
        return {
            ...state,
            isLoading: true,
            error: null
        };

        case FETCH_USER_DATA_SUCCESS:
        return {
            ...state,
            error: null,
            isLoading: false,
            data: action.payload.data
        };

        case LEAVE_ROOM_SUCCESS:
        return {
            ...state,
            error: null,
            isLoading: false,
            data: {
                ...state.data,
                room: null
            }
        };

        case FETCH_USER_DATA_ERROR:
        case LEAVE_ROOM_ERROR:
        return {
            ...state,
            isLoading: false,
            error: action.payload.error,
        };

        default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/User/redux/userRoomsReducer.js